<template>
  <div class="container">
    <div class="title">
      <div class="rowOne">
        <span style="color: red; font-size: 17px">*</span>模板名称：
        <a-input
          ref="userNameInput"
          v-model="templteInfo.templeName"
          placeholder="模板名"
          style="width: 30%; margin-right: 1%"
        >
          <a-icon slot="prefix" type="pushpin" />
          <a-tooltip slot="suffix" title="模板名称">
            <a-icon type="info-circle" style="color: rgba(0, 0, 0, 0.45)" />
          </a-tooltip>
        </a-input>
        <span style="color: red; font-size: 17px">*</span>短信类型：
        <a-select
          style="width: 30%; margin-right: 1%"
          @select="chooseWhat"
          placeholder="短信类型"
          v-model="templteInfo.messageType"
          show-search
          @focus="getMessageTypeOpenion()"
        >
          <a-select-option v-for="(value, index) in messageType" :key="index" :value="value">{{
            value
          }}</a-select-option>
        </a-select>
      </div>
      <div class="rowTwo" style="margin-top: 2%">
        <span style="color: red; font-size: 17px">*</span>发送数量：
        <a-input-number
          id="inputNumber"
          v-model="templteInfo.messageNum"
          :min="1"
          style="width: 30%; margin-right: 1%"
        />
        <span style="color: red; font-size: 17px">*</span>短信来源：
        <a-select
          style="width: 30%; margin-right: 1%"
          @select="sourceChooseWhat"
          show-search
          placeholder="短信来源"
          v-model="templteInfo.sources"
        >
          <a-select-option v-for="value in sourceOpenion" :key="value.id" :value="value.sources">{{
            value.sources
          }}</a-select-option>
        </a-select>
      </div>
      <div class="rowTwo" style="margin-top: 2%">
        <span style="color: red; font-size: 17px">*</span>短信分类：
        <j-dict-select-tag
          style="width: 30%; margin-right: 1%"
          placeholder="短信分类"
          dictCode="message_type_code"
          @input="handleMessageTypeCodeChange"
          v-model="templteInfo.smsType"
        >
        </j-dict-select-tag>
        <span style="color: red; font-size: 17px">*</span>app名称：
        <j-dict-select-tag
          style="width: 30%; margin-right: 1%"
          placeholder="appName："
          ref="AppNameSelect"
          @input="handleAppNameChange"
          v-model="templteInfo.cmAppId"
        >
        </j-dict-select-tag>
      </div>
      <div class="rowTwo" style="margin-top: 2%">
        <span style="color: red; font-size: 17px">*</span>发送账号：
        <a-input
          disabled
          style="width: 30%; margin-right: 1%"
          v-model="templteInfo.cmAccount"
        >
        </a-input>
        <span style="color: red; font-size: 17px">*</span>appId：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        <a-input
          disabled
          style="width: 30%; margin-right: 1%"
          v-model="templteInfo.cmAppId"
        >
        </a-input>
      </div>
      <div class="memoText">
        备注(100字内)：
        <a-textarea
          placeholder="备注信息"
          v-model="templteInfo.memo"
          :auto-size="{ minRows: 3, maxRows: 6 }"
          :maxLength="100"
        />
      </div>
    </div>
    <div class="addbuttongroup">
      <h3>填写短信模板</h3>
      <a-modal
        title="添加元素"
        :visible="visible"
        :confirm-loading="confirmLoading"
        @ok="reSettleList(chooseid)"
        @cancel="visible = false"
      >
        <a-radio-group button-style="solid" v-model="chooseWhatValue">
          <a-radio :value="1">文字内容</a-radio>
          <a-radio :value="2">短信参数</a-radio>
        </a-radio-group>
        <a-textarea
          placeholder="要添加的文字"
          v-model="messageTxet"
          v-if="chooseWhatValue == 1"
          :auto-size="{ minRows: 3, maxRows: 6 }"
          :maxLength="70"
          style="margin-top: 10px"
        />
        <span v-if="chooseWhatValue == 1">{{ this.messageTxet.length + '/70' }}</span>
      </a-modal>
    </div>
    <div class="body">
      <template class="tagbody" v-for="item in messageContentShow">
        <a-tag
          closable
          @close="delTag(item.id)"
          :color="item.color"
          :key="item.id"
          v-if="item.type != 'button'"
          class="tagStyle"
          :visible="true"
          @click="isText(item.id)"
          >{{ item.text }}</a-tag
        >
        <a-tag
          v-if="item.type == 'button'"
          :color="item.color"
          :key="item.id"
          class="tagStyle"
          @click="isText(item.id)"
        >
          <a-icon type="plus" />
        </a-tag>
      </template>
    </div>
    <a-modal
      title="修改文字内容"
      :visible="changeTextContent"
      :confirm-loading="changeTextContentLoading"
      @ok="changeText(chooseTextId)"
      @cancel="changeTextContent = false"
    >
      <a-textarea
        placeholder="要修改的文字"
        v-model="changeMessageText"
        :auto-size="{ minRows: 3, maxRows: 6 }"
        :maxLength="70"
      />
      <span>{{ this.changeMessageText.length + '/70' }}</span>
    </a-modal>
    <div class="commitbuttongroup">
      <a-button type="primary" @click="sumitMessageTemple" :loading="buttonLoading" v-if="!isChange">提交</a-button>
      <a-button type="primary" @click="changeMessageTemple" :loading="buttonLoading" v-else>保存</a-button>
      <a-button @click="colseChangeDrawer" style="margin-left: 1%" v-if="isChange">取消修改</a-button>
      <a-button @click="colseDrawer" style="margin-left: 1%" v-else>取消</a-button>
      <a-button style="margin-left: 1%" @click="lookMessageContents">短信预览</a-button>
    </div>
    <a-modal v-model="showMessage" title="短信预览">
      <p style="font-size: 10px; font-weight: 600">计费规则：</p>
      <p style="font-size: 10px; line-height: 12px">短信字数=短信内容 +签名字数</p>
      <p style="font-size: 10px; line-height: 12px">短信字数小于70个字数，按照70个字数一条短信计算</p>
      <p style="font-size: 10px; line-height: 12px">短信字数大于70个字数，即为长短信，按照67个字数记为一条短信计算</p>
      <show-phone-message :contents="contents"></show-phone-message>
      <template slot="footer">
        <p style="font-size: 12px">{{ '总' + contents.length + '字' }}</p>

        <a-button key="submit" type="primary" @click="showMessage = false">确认</a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import {
  addMessageTemple,
  upadteMessageTemlate,
  getMessageType,
  getMssageContentView,
  getSourcesSelecetOpion,
  getListBySmsType
} from '@/api/api'
import showPhoneMessage from './showPhoneMessage'
import JDictSelectTag from '../../../components/dict/JDictSelectTag.vue'

export default {
  //接收子组件传递过来的模板信息
  props: {
    templte: {
      type: Object,
    },
  },
  components: {
    showPhoneMessage,
    JDictSelectTag,
  },
  data() {
    return {
      //模板信息
      templteInfo: {
        templeName: '',
        messageType: '',
        messageNum: 1,
        sources: '',
        memo: '',
        sourcesid: '',
        cmAppName:'',
        smsType: '',
        cmAppId: '',
        cmAccount: '',
      },
      //选中的模板id
      chooseTemplateCode: '',
      //选中修改的元素id
      chooseTextId: '',
      //要添加文字内容
      messageTxet: '',
      //修改的文字内容
      changeMessageText: '',
      //是否显示模态框
      visible: false,
      //是否加载状态
      confirmLoading: false,
      //是否显示修改文字模态框
      changeTextContent: false,
      //修改文字模态框是否加载状态
      changeTextContentLoading: false,
      //提交按钮是否加载
      buttonLoading: false,
      //短信类型数组
      messageType: [],
      //短信来源选择器数组
      sourceOpenion: [],
      //模板内容数组
      messageContent: [],
      //模板内容展示的数组
      messageContentShow: [],
      //是否修改模板的状态下
      isChange: false,
      //文字或者参数
      chooseWhatValue: 1,
      //选中的+号id
      chooseid: '',
      showMessage: false,
      contents: '',
      parmsNum: 0,
      signatures: '【金牌厨柜】',
      signaturesList: [],
      newCMAccountList:[],
    }
  },
  mounted() {
    this.updateTemplateInfo()
    this.getSourceOpenion()
  },
  watch: {
    //监听父组件传过来的模板信息
    templte: 'updateTemplateInfo',
  },
  methods: {
    //短信类型更改
    handleMessageTypeCodeChange(value){
      this.$set(this.templteInfo,'cmAppId','')
      this.$set(this.templteInfo,'smsType',value)
      this.$set(this.templteInfo,'cmAccount','')
      getListBySmsType({smsType:value}).then((res)=>{
        if(res.code==200){
          this.newCMAccountList=res.result;
          let dictMap=this.newCMAccountList.map((data)=>{
            return {
              label:data.appName,
              value:data.appId,
            }
          })
          this.$refs.AppNameSelect.setCurrentDictOptions(dictMap)
        }
      })
    },
    //appName更改
    handleAppNameChange(value){
      this.newCMAccountList.some((item)=>{
        if(item.appId===value){
          this.$set(this.templteInfo,'cmAppId',item.appId)
          this.$set(this.templteInfo,'cmAccount',item.account)
          return true
        }
        return false
      })
      // this.$set(this.templteInfo,'cmAppName',value)
    },
    //获取选择器选项
    getMessageTypeOpenion() {
      getMessageType().then((res) => {
        if (res.success) {
          this.messageType = res.result.value
          this.signaturesList = res.result.signatures
          if (this.templteInfo.messageType != '' && this.templteInfo.messageType != null) {
            this.getSignatures(this.templteInfo.messageType)
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getSourceOpenion() {
      let requestParms = {
        id: this.$ls.get('Login_Userinfo').id,
      }
      getSourcesSelecetOpion(requestParms).then((res) => {
        if (res.success) {
          this.sourceOpenion = res.result
        } else {
          this.$message.error(res.message)
        }
      })
    },
    async lookMessageContents() {
      this.messageContent = []
      for (var i = 0; i < this.messageContentShow.length; i++) {
        //遍历一遍展示list
        if (this.messageContentShow[i].type != 'button') {
          let date = {
            id: this.messageContent.length,
            text: this.messageContentShow[i].text,
            type: this.messageContentShow[i].type,
            color: this.messageContentShow[i].color,
          }
          this.messageContent.push(date)
        }
      }
      let parmsNum = 0
      let contentsResult = ''
      for (var i = 0; i < this.messageContent.length; i++) {
        if (this.messageContent[i].type == 'parms') {
          parmsNum += 1
          contentsResult = contentsResult + '[参数位]'
        } else {
          contentsResult = contentsResult + this.messageContent[i].text
        }
      }
      this.contents = this.signatures + contentsResult
      this.showMessage = true
    },
    updateTemplateInfo() {
      //修改模板信息发生变化的话对模板信息内容进行更新
      if (this.templte != null) {
        this.messageContent = []
        this.templteInfo.templeName = this.templte.tempName
        this.templteInfo.messageType = this.templte.type
        this.getMessageTypeOpenion()
        this.templteInfo.messageNum = this.templte.sendNum
        this.templteInfo.sources = this.templte.sources
        this.templteInfo.memo = this.templte.memo
        this.chooseTemplateCode = this.templte.tempCode
        this.parmsNum = this.templte.paramsNum
        this.templteInfo.sourcesid = this.templte.sourcesId
        this.templteInfo.smsType=this.templte.smsType,
        this.templteInfo.cmAppId=this.templte.cmAppId,
        this.templteInfo.cmAccount=this.templte.cmAccount,
        this.isChange = true
        getListBySmsType({smsType:this.templte.smsType}).then((res)=>{
          if(res.code==200){
            this.newCMAccountList=res.result;
            let dictMap=this.newCMAccountList.map((data)=>{
              return {
                label:data.appName,
                value:data.appId,
              }
            })
            this.$refs.AppNameSelect.setCurrentDictOptions(dictMap)
          }
        })
        this.initMessageContents(this.templte.contents, this.templte.paramsNum)
      } else {
        //非编辑状态下
        this.reinitMessageContents()
      }
    },
    chooseWhat(value) {
      //接收短信类型修改结果
      this.templteInfo.messageType = value
    },
    getSignatures(value) {
      if (this.messageType.length != 0 && this.messageType != null && value != '' && value != null) {
        for (var i = 0; i < this.messageType.length; i++) {
          if (this.messageType[i] == value) {
            this.signatures = this.signaturesList[i]
            return
          }
        }
      } else {
        this.$message.error('网络环境差,签名获取可能错误！')
      }
    },
    sourceChooseWhat(key, value) {
      this.templteInfo.sources = key
      this.templteInfo.sourcesid = value.key
    },
    delTag(id) {
      //处理点tag标签X掉的方法
      this.messageContentShow.splice(id - 1, 2)
      let messageCOntentShowBuffer = []

      //更新后续元素对应id
      for (let i = 0; i < this.messageContentShow.length; i++) {
        this.messageContentShow[i].id = i
        messageCOntentShowBuffer.push(this.messageContentShow[i])
      }
      this.messageContentShow = messageCOntentShowBuffer
      console.log(this.messageContentShow)
    },
    isText(id) {
      //选中标签时进行判断，如果是text显示编辑文字界面，如果是button弹出添加模态框，如果是参数弹出对应提示
      if (this.messageContentShow[id].type == 'text') {
        this.changeTextContent = true
        this.chooseTextId = id
        this.changeMessageText = this.messageContentShow[id].text
      } else if (this.messageContentShow[id].type == 'button') {
        this.visible = true
        this.chooseid = id
      } else {
        this.$message.error('参数是不能改的哦！>_<')
      }
    },
    changeText(id) {
      //修改对应标签id的文字
      this.messageContentShow[id].text = this.changeMessageText
      this.changeTextContent = false
    },
    //提交要添加的模板
    sumitMessageTemple() {
      this.messageContentShowToMessageContent()
      //内容校验
      if(!this.templteInfo.smsType){
        this.$message.error('请选择短信分类')
        return
      }
      if(!this.templteInfo.cmAppId){
        this.$message.error('请选择APP名称')
        return
      }
      if (this.templteInfo.templeName == '') {
        this.$message.error('模板名称一定得填的哦！(；′⌒`)')
      } else if (this.templteInfo.sources == '') {
        this.$message.error('信息源一定得填！(T＿T)')
      } else if (this.templteInfo.messageType == '请选择短信类型') {
        this.$message.error('短信类型选一下嘛！(ಥ﹏ಥ)')
      } else if (this.messageContent.length == 0) {
        console.log(this.messageContent)
        this.$message.error('模板不写不让交￣へ￣')
      } else {
        //处理模板list成一个字符串
        this.buttonLoading = true
        let parmsNum = 0
        let contents = ''
        for (var i = 0; i < this.messageContent.length; i++) {
          if (this.messageContent[i].type == 'parms') {
            parmsNum += 1
            contents = contents + '{' + parmsNum + '}'
          } else {
            contents = contents + this.messageContent[i].text
          }
        }
        //提交请求参数  contents：模板内容  memo：备注 paramsNum：参数个数 sendNum：发送次数限制 sources：来源 tempName：模板名称 type：短信类型
        let sumitDate = {
          contents: contents,
          createBy: this.$ls.get('Login_Userinfo').realname,
          memo: this.templteInfo.memo,
          paramsNum: parmsNum,
          sendNum: this.templteInfo.messageNum,
          sources: this.templteInfo.sources,
          sourcesid: this.templteInfo.sourcesid,
          tempName: this.templteInfo.templeName,
          type: this.templteInfo.messageType,
          smsType: this.templteInfo.smsType,
          cmAppId: this.templteInfo.cmAppId,
          cmAccount: this.templteInfo.cmAccount,
        }
        addMessageTemple(sumitDate).then((res) => {
          if (res.success) {
            this.buttonLoading = false
            this.$emit('addTemple', false)
          } else {
            this.$message.error('添加模板失败:' + res.message)
            this.buttonLoading = false
          }
        })
      }
    },
    //关闭抽屉
    colseDrawer() {
      //清空模板lsit
      this.messageContent = []
      //清空模板显示list
      this.messageContentShow = []
      //重新初始化模板显示list
      this.reinitMessageContents()
      //提交给父组件关闭抽屉
      this.$emit('addTemple', false)
    },
    colseChangeDrawer() {
      //清空模板信息内容
      let newtemplteInfo = {
        templeName: '',
        messageType: '请选择短信类型',
        messageNum: 1,
        sources: '',
        memo: '',
        smsType: '',
        cmAppId: '',
        cmAccount: '',
      }
      //清空模板list
      this.messageContentShow = []
      this.messageContent = []
      //重新初始化模板list
      this.reinitMessageContents()
      //修改模板信息为新的空模板信息
      this.templteInfo = newtemplteInfo
      //修改为不是修改模板状态
      this.isChange = false
      //提交给父组件关闭抽屉
      this.$emit('addTemple', false)
    },
    initMessageContents(str, parmsNum) {
      //传入短信模板和参数个数
      let requestParms = {
        messagecontent: str,
      }
      getMssageContentView(requestParms).then((res) => {
        this.messageContent = res.result
        //清空显示list
        this.messageContentShow = []
        //初始化显示list
        this.reinitMessageContents()
      })
    },
    //修改模板信息
    changeMessageTemple() {
      //将显示list转换成消息list
      this.messageContentShowToMessageContent()
      //信息校验
      if(!this.templteInfo.smsType){
        this.$message.error('请选择短信分类')
        return
      }
      if(!this.templteInfo.cmAppId){
        this.$message.error('请选择APP名称')
        return
      }
      if (this.templteInfo.templeName == '') {
        this.$message.error('模板名称一定得填的哦！(；′⌒`)')
      } else if (this.templteInfo.sources == '') {
        this.$message.error('信息源一定得填！(T＿T)')
      } else if (this.templteInfo.messageType == '请选择短信类型') {
        this.$message.error('短信类型选一下嘛！(ಥ﹏ಥ)')
      } else if (this.messageContent.length == 0) {
        this.$message.error('模板不写不让交￣へ￣')
      } else {
        this.buttonLoading = true
        let parmsNum = 0
        let contents = ''
        for (var i = 0; i < this.messageContent.length; i++) {
          if (this.messageContent[i].type == 'parms') {
            parmsNum += 1
            contents = contents + '{' + parmsNum + '}'
          } else {
            contents = contents + this.messageContent[i].text
          }
        }
        //修改模板信息请求参数表
        //contents：新的模板内容  memo：新的备注 paramsNum：参数个数  type：模板类型
        //sendNum：发送次数限制 sources：来源 tempCode：模板id tempName：模板名称
        let changeDate = {
          contents: contents,
          memo: this.templteInfo.memo,
          paramsNum: parmsNum,
          sendNum: this.templteInfo.messageNum,
          sources: this.templteInfo.sources,
          sourcesid: this.templteInfo.sourcesid,
          tempCode: this.chooseTemplateCode,
          tempName: this.templteInfo.templeName,
          type: this.templteInfo.messageType,
          updateby: this.$ls.get('Login_Userinfo').realname,
          smsType: this.templteInfo.smsType,
          cmAppId: this.templteInfo.cmAppId,
          cmAccount: this.templteInfo.cmAccount,
        }
        upadteMessageTemlate(changeDate).then((res) => {
          this.buttonLoading = false
          console.log(res)
          if (res.code == 200) {
            this.$message.success('修改成功')
            this.colseChangeDrawer()
          } else {
            this.$message.error('修改失败')
          }
        })
      }
    },
    //初始化显示的模板信息list
    async reinitMessageContents() {
      if (this.messageContentShow.length == 0) {
        let oneButton = {
          id: this.messageContentShow.length,
          text: '' + this.messageContentShow.length,
          type: 'button',
          color: 'orange',
        }
        this.messageContentShow.push(oneButton)
      }
      for (var i = 0; i < this.messageContent.length; i++) {
        let parms = {
          id: this.messageContentShow.length,
          text: this.messageContent[i].text,
          type: this.messageContent[i].type,
          color: this.messageContent[i].color,
        }
        this.messageContentShow.push(parms)
        let Button = {
          id: this.messageContentShow.length,
          text: '',
          type: 'button',
          color: 'orange',
        }
        this.messageContentShow.push(Button)
      }
    },
    //修改后对后面元素的id进行更新
    reSettleList(id) {
      if (this.messageTxet.length == 0 && this.chooseWhatValue == 1) {
        this.$message.error('文本不能为空')
      } else {
        if (this.chooseWhatValue == 1) {
          let text = {
            id: id + 1,
            text: this.messageTxet,
            type: 'text',
            color: '#108ee9',
          }
          this.messageContentShow.splice(id + 1, 0, text)
          let Button = {
            id: id + 2,
            text: ' + ',
            type: 'button',
            color: 'orange',
          }
          this.messageContentShow.splice(id + 2, 0, Button)
          this.visible = false
          this.messageTxet = ''
        } else {
          let parms = {
            id: id + 1,
            text: '{参数}',
            type: 'parms',
            color: '#87d068',
          }
          this.messageContentShow.splice(id + 1, 0, parms)
          let Button = {
            id: id + 2,
            text: ' + ',
            type: 'button',
            color: 'orange',
          }
          this.messageContentShow.splice(id + 2, 0, Button)
          this.visible = false
        }
        for (var i = id + 3; i < this.messageContentShow.length; i++) {
          //更新id
          this.messageContentShow[i].id += 2
        }
      }
    },
    messageContentShowToMessageContent() {
      //清空原来的参数列表
      this.messageContent = []
      for (var i = 0; i < this.messageContentShow.length; i++) {
        //遍历一遍展示list
        if (this.messageContentShow[i].type != 'button') {
          let date = {
            id: this.messageContent.length,
            text: this.messageContentShow[i].text,
            type: this.messageContentShow[i].type,
            color: this.messageContentShow[i].color,
          }
          this.messageContent.push(date)
        }
      }
      //清空messageContentShow
      // this.messageContentShow = []
    },
  },
}
</script>


<style scoped>
.commitbuttongroup {
  margin-top: 1%;
}
.memoText {
  width: 85%;
  margin-top: 1%;
}
.body {
  width: 100%;
  height: 400px;
  margin-top: 2%;
  border: 1px dashed #000;
  padding-left: 0.5%;
  display: flexbox;
}
.tagbody {
  width: 100%;
  height: 500px;
}
.tagStyle {
  font-size: 14px;
  margin-top: 1%;
  font-weight: 300;
  height: 34px;
  line-height: 34px;
  display: noset;
}
</style>
